import { render, staticRenderFns } from "./StartForgotPassword.vue?vue&type=template&id=11730be7&"
import script from "./StartForgotPassword.vue?vue&type=script&lang=ts&"
export * from "./StartForgotPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports